import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

let cachedOffers = null;

export const useOffers = () => {
  const [offers, setOffers] = useState(cachedOffers ?? []);
  const [loading, setLoading] = useState(cachedOffers === null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiService.getOffers()
      .then((data) => {
        cachedOffers = data;
        setOffers(data);
        setError(null);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { offers, loading, error };
};
